module.exports = __webpack_public_path__ + "static/media/18ECA24.7e8bbe22.jpg";